// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ConditionalFormattingFormatPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module ConditionalFormattingFormatPopup popup component
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {  getOr } from 'lodash/fp';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import DropDown from 'share/components/controls/Izenda.DropDown';
import InputByDataType from 'share/components/controls/Izenda.InputByDataType';
import FontFormat from 'share/components/controls/Izenda.FontFormat';
import FontStyle from 'share/components/controls/Izenda.FontStyle';
import ConditionalFormattingFormat from './Izenda.ConditionalFormattingFormat';
import connect from 'share/enhancers/Izenda.Connect';
import constants from 'logic/data/Izenda.ConditionalFormattingConstants';

const {FORMAT_TYPE, INPUT_DATA_TYPE} = constants;

@observer
class ConditionalFormattingFormatPopup extends Component {
  format;

  constructor(props) {
    super(props);
    const {format} = props;
    this.format = new ConditionalFormattingFormat(format);
  }

  renderFormatTypeRow(format, localization){
    const formatTypesOptions = [];
    formatTypesOptions.push(FORMAT_TYPE.BACKGROUND_COLOR);
    formatTypesOptions.push(FORMAT_TYPE.FONT_COLOR);
    formatTypesOptions.push(FORMAT_TYPE.FONT_FORMAT);
    formatTypesOptions.push(FORMAT_TYPE.ALTERNATIVE_TEXT);

    const onFormatTypeChange = (newValue) => {
      format.setFormatType(newValue);
    }

    return (
      <GridLayout.Row>
        <GridLayout.Col className="u_controlHeight" cols={3}>{localization.getText('CONDITIONAL_FORMATTING_LABEL_FORMAT_TYPE')}</GridLayout.Col>
        <GridLayout.Col cols={9}>
          <DropDown value={format.type.value} options={formatTypesOptions} onChange={onFormatTypeChange} valueField="value" labelField="title"/>
        </GridLayout.Col>
      </GridLayout.Row>
    );
  }

  renderFormatValueRow(format, localization){
    const formatType = getOr('', 'type.value', format);
    if(formatType === '')
      return;

    const onFormatSimpleValueChange = (newValue) => {
      format.value = newValue.value;
    }

    const onFontFormatValueChange = (newValue) => {
      format.value.font = newValue.value;
    }

    const onFontStyleValueChange = (newValue) => {
      format.value.style = newValue.value;
    }    

    return (
      <GridLayout.Row>
        <GridLayout.Col className="u_controlHeight" cols={3}>{localization.getText('CONDITIONAL_FORMATTING_LABEL_FORMAT_VALUE')}</GridLayout.Col>
        <GridLayout.Col cols={9}>
          {
            formatType === FORMAT_TYPE.BACKGROUND_COLOR.value &&
            <InputByDataType value={format.value} onChange={onFormatSimpleValueChange} type={INPUT_DATA_TYPE.COLOR} />
          }
          {
            formatType == FORMAT_TYPE.FONT_COLOR.value &&
            <InputByDataType value={format.value} onChange={onFormatSimpleValueChange} type={INPUT_DATA_TYPE.COLOR} />
          }
          {
            formatType == FORMAT_TYPE.ALTERNATIVE_TEXT.value &&
            <InputByDataType value={format.value} onChange={onFormatSimpleValueChange} type={INPUT_DATA_TYPE.TEXT} />
          }
          {
            formatType == FORMAT_TYPE.FONT_FORMAT.value &&
            (
              <div>
                <div style={{'marginBottom': '10px'}}><FontFormat onChange={onFontFormatValueChange} value={format.value.font} /></div>
                <div><FontStyle onChange={onFontStyleValueChange} value={format.value.style} /></div>
              </div>
            )
          }
        </GridLayout.Col>
      </GridLayout.Row>
    );
  }

  render() {
    const {renderFormatTypeRow, renderFormatValueRow, format, props: { localization, onReject, onAccept, onFormatChange }} = this;

    const onClosing = (callback, type) => {
      if(type === 'accept'){
        const formatData = format.serializeData();
        onFormatChange(formatData);
        onAccept();
      }else{
        onReject();
      }
    };

    return (
      <Popup visible onClosing={onClosing} autoClose={false} type="none" sizeClass="modal-sm">
        <Popup.Header title={localization.getText('CONDITIONAL_FORMATTING_FORMAT_POPUP_TITLE')} />
        <Popup.Body>
          <div className="izenda-ConditionalFormattingFormat">
            <GridLayout>
              {renderFormatTypeRow(format, localization)}
              {renderFormatValueRow(format, localization)}
            </GridLayout>
          </div>
        </Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton type="accept">{localization.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
          <Popup.ConfirmationButton type="cancel">{localization.getText('COMMON_LABEL_CANCEL')}</Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}

const popupWindow = connect()(ConditionalFormattingFormatPopup);
popupWindow.displayName  = 'ConditionalFormattingFormatPopup';
export default popupWindow;


// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/ConditionalFormatting/Izenda.ConditionalFormattingFormatPopup.jsx